/**
 * A feed section's title and optional subtitle (Figma 9154:8266), with an
 * optional header link (`action: {label, onClick}`) — the Active rail's
 * "View All" (Figma 11115:27005).
 */
function SectionHead({ title, subtitle, action }) {
  return (
    <div className="ex-section__head">
      {action ? (
        <div className="ex-section__titlerow">
          <h2 className="ex-section__title">{title}</h2>
          <button type="button" className="ex-section__link" onClick={action.onClick}>
            {action.label}
          </button>
        </div>
      ) : (
        <h2 className="ex-section__title">{title}</h2>
      )}
      {subtitle && <p className="ex-section__subtitle">{subtitle}</p>}
    </div>
  );
}

export default SectionHead;
